import React from 'react'
import PropTypes from 'prop-types'
import { CustomTooltip } from '../CustomTooltip/CustomTooltip'
import { getTranslationForKey } from '../../../resources/renderingUtilities'
import './style.css'

class ImageThumbnail extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      imageStatus: 'loading-circular-image'
    }
    this.handleImageLoaded = this.handleImageLoaded.bind(this)
  }

  handleImageLoaded () {
    this.setState({ imageStatus: '' })
  }

  componentDidMount () {
    this.setState({
      imageStatus: ''
    })
  }

  render () {
    return (
      <div>
        <CustomTooltip tooltipPosition={this.props.tooltipPosition} key={this.props.imageDescription} toolTipText={getTranslationForKey(this.props.imageDescription)}>
          <div className='thumbnail image-thumbnail no-border'>
            <img className={this.state.imageStatus} onLoad={this.handleImageLoaded} src={this.props.image} alt={this.props.imageDescription} />
            <div className='caption'>
              {this.props.children}
            </div>
          </div>
        </CustomTooltip>
      </div>
    )
  }
}
ImageThumbnail.propTypes = {
  image: PropTypes.string.isRequired,
  imageDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  handleImageLoaded: PropTypes.func,
  tooltipPosition: PropTypes.string
}

export { ImageThumbnail }



// WEBPACK FOOTER //
// ./src/components/common/ImageThumbnail/ImageThumbnail.js